export default {
  methods: {
    copyId(id) {
      navigator.clipboard.writeText(id);
    },
  },
};
